module.exports = "/_next/static/images/2db98dfeaa5d797214a411818a6216e5-cristina-mobile.jpg";